module.exports = __webpack_public_path__ + "static/media/gb.94cb9756.svg";